module.exports = __webpack_public_path__ + "static/media/showroom_armani_840x520.5fbf94c8.jpg";